module.exports = "/next-static/_next/static/images/block_image_giveaways-dfc8af2f09936cf199d675274baefadb.webp";